<!-----------------------------------------------------------------------------
  Copyright (c) 2016 - 2021.                                                  -
  Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)           -
  All Rights Reserved.                                                        -
                                                                              -
  The software and data contained herein are confidential and proprietary     -
  information of Yega Yazilim ("Confidential Information").                   -
                                                                              -
  Users of this software may not disclose such Confidential Information and   -
  shall use it only in accordance with the terms of the license agreement     -
  they entered into with Yega Yazilim.                                        -
                                                                              -
  Author:  Ahmet Dogramaci                                                    -
  Date:    2021-01-14                                                         -
  ----------------------------------------------------------------------------->

<template>
  <b-modal ref="loadingSpinnerModal"
           centered
           @hidden="handleHidden"
           no-close-on-backdrop
           no-close-on-esc
           :hide-footer="!canClose"
           :aria-label="displayMessage"
           header-bg-variant="primary"
           header-text-variant="light">
    <template #modal-header>
      <h5 class="modal-title">{{ displayMessage }}</h5>
    </template>
    <template #modal-footer>
      <b-button variant="secondary" @click="dismiss">Close</b-button>
    </template>
    <b-progress>
      <b-progress-bar :value="100" variant="primary" animated>
      </b-progress-bar>
    </b-progress>
  </b-modal>
</template>

<script>
export default {
  name: "yega1-loading-spinner",
  data() {
    return {
      spinnerStore: this.$store.state.LoadingSpinnerStore,
      is_shown: false,
      isClosing: false,
      dismissed: false,
      startedAt: 0,
      elapsedMs: 0,
      spinnerTimer: null,
      hideTimer: null
    };
  },
  props: {
    message: {
      type: String,
      default: 'Loading...'
    }
  },
  mounted() {
    if (this.spinnerStore.count > 0) this.callShow();
  },
  beforeUnmount() {
    this.clearTimers();
  },
  watch: {
    'spinnerStore.count': {
      // Observe even a 1 → 0 → 1 sequence in the same tick, particularly after
      // dismissal. This does not change which HTTP requests the store counts.
      flush: 'sync',
      handler(newCount, oldCount) {
        console.log(`spinnerStore.count. oldCount:${oldCount}, newCount:${newCount}`);
        if (newCount <= 0) {
          this.dismissed = false;
          clearTimeout(this.spinnerTimer);
          if (this.is_shown && !this.isClosing) this.handleReadyToHide();
        } else if (oldCount <= 0) {
          clearTimeout(this.hideTimer);
          if (!this.is_shown) this.callShow();
          else if (!this.isClosing) this.callHide();
          // A closing modal is reopened only by handleHidden, never queued here.
        }
      }
    }
  },
  computed: {
    displayMessage() {
      return this.elapsedMs >= 10000 ? 'Still working…' : this.message;
    },
    canClose() {
      return this.elapsedMs >= 180000 && this.spinnerStore.count > 0;
    }
  },
  methods: {
    clearTimers() {
      clearTimeout(this.spinnerTimer);
      clearTimeout(this.hideTimer);
    },
    callShow() {
      if (this.is_shown || this.dismissed) return;
      this.clearTimers();
      this.startedAt = Date.now();
      this.elapsedMs = 0;
      this.is_shown = true;
      this.$refs.loadingSpinnerModal.show();
      this.callHide();
    },
    callHide() {
      clearTimeout(this.spinnerTimer);
      if (this.isClosing || this.dismissed) return;
      // Elapsed time, rather than tick counts, also works in throttled tabs.
      this.elapsedMs = Date.now() - this.startedAt;
      if (this.spinnerStore.count <= 0) {
        console.log(`callHide, spinner ready to hide. Elapsed: ${this.elapsedMs}, spinner store count:${this.spinnerStore.count}`);
        this.handleReadyToHide();
      } else {
        console.log(`callHide, spinner NOT ready to hide. Elapsed: ${this.elapsedMs}, spinner store count:${this.spinnerStore.count}`);
        this.spinnerTimer = setTimeout(() => this.callHide(), 100);
      }
    },
    handleReadyToHide() {
      clearTimeout(this.hideTimer);
      this.hideTimer = setTimeout(() => {
        // A chained request may have started during the grace period.
        if (this.spinnerStore.count > 0 || this.isClosing) return;
        this.isClosing = true;
        this.$refs.loadingSpinnerModal.hide();
      }, 100);
    },
    dismiss() {
      if (!this.canClose || this.isClosing) return;
      // Close dismisses only this pending group; it neither cancels requests nor
      // changes the counter. A later idle → busy transition starts normally.
      this.dismissed = true;
      this.clearTimers();
      this.isClosing = true;
      this.$refs.loadingSpinnerModal.hide();
    },
    handleHidden() {
      this.clearTimers();
      this.is_shown = false;
      this.isClosing = false;
      this.elapsedMs = 0;
      if (this.spinnerStore.count > 0 && !this.dismissed) this.callShow();
    }
  }
}
</script>

<style scoped>

</style>
